import React from "react";
import Navigation from "./Navigation";
import Legal from "./Legal";
import styles from "./SurveyComplete.module.scss";
import { useTrackPageVisit } from "../hooks/useTrackPageVisit";

const SURVEY_COMPLETE_MESSAGE =
  "Thank you for completing the ENGIE Tracker survey!";

export default function SurveyComplete() {
  useTrackPageVisit("survey_complete", "");

  return (
    <div className={styles.page}>
      <Navigation />
      <main className={styles.main}>
        <p className={styles.message}>{SURVEY_COMPLETE_MESSAGE}</p>
      </main>
      <Legal hideSettings />
    </div>
  );
}
